import { useContext } from "react";
import { ToolbarFiltersContext } from "./ToolbarFiltersProvider";

export default function useToolbarFiltersContext() {
    return useContext(ToolbarFiltersContext);
};
